module.exports = __webpack_public_path__ + "img/About_Desktop_02.c9ef92dd.jpg";